export const TOGGLE_CARD = 'TOGGLE_CARD';
export const TOGGLE_CALENDAR = 'TOGGLE_CALENDAR';
export const TOGGLE_MODAL = 'TOGGLE_MODAL';
export const TOGGLE_SUCCESS_MESSAGE = 'TOGGLE_SUCCESS_MESSAGE';
export const TOGGLE_ROLE_POPOUT = 'TOGGLE_ROLE_POPOUT';

/* ----------------------- Get Client Data -----------------------*/

export function toggleOptionCard(card = null) {
    // eslint-disable-next-line no-nested-ternary
    const data =
        // eslint-disable-next-line no-nested-ternary
        card === 'role'
            ? { roleExtras: true, shiftTimes: false }
            : card === 'time'
                ? { roleExtras: false, shiftTimes: true }
                : { roleExtras: false, shiftTimes: false };

    return {
        type: 'TOGGLE_CARD',
        payload: data,
    };
}

export function toggleCalendar(data) {
    return {
        type: 'TOGGLE_CALENDAR',
        payload: data,
    };
}

export function toggleModal(modal, type) {
    return {
        type: 'TOGGLE_MODAL',
        payload: { modal, type },
    };
}

export function toggleSuccessMessage(data) {
    return {
        type: 'TOGGLE_SUCCESS_MESSAGE',
        payload: data,
    };
}

export function toggleRolePopout(popOut, type) {
    return {
        type: TOGGLE_ROLE_POPOUT,
        payload: { popOut, type },
    };
}
